import type { IStock } from '@interfaces/product';

export function getDefaultStoreId(
	parameters?: {
		defaultStorehouseId?: number | null;
		defaultStoreId?: number;
	} | null
): number | undefined {
	return parameters?.defaultStorehouseId ?? parameters?.defaultStoreId;
}

export function getTotalStock(
	stocks?: IStock[] | null,
	storeId?: number | null
): number {
	const items = stocks || [];
	const filtered =
		storeId == null ? items : items.filter(stock => stock.storeId === storeId);

	const total = filtered.reduce((sum, stock) => sum + (stock.quantity || 0), 0);

	return Math.max(0, total);
}

export function shouldShowStockToClient(
	stocks?: IStock[] | null,
	showStockToClient?: boolean
): boolean {
	return !!showStockToClient && stocks != null;
}

export function hasStockQuantityInfo(stocks?: IStock[] | null): boolean {
	return stocks != null;
}

export function isProductSellable(
	product: { available?: boolean; stocks?: IStock[] | null } | null | undefined,
	allowSellingWithoutStock?: boolean,
	storeId?: number | null
): boolean {
	if (allowSellingWithoutStock) return true;
	if (product?.available === true) return true;
	if (product?.available === false) return false;
	return getTotalStock(product?.stocks, storeId) > 0;
}

export function isProductOutOfStock(
	product: { available?: boolean; stocks?: IStock[] | null } | null | undefined,
	storeId?: number | null
): boolean {
	if (product?.available === true) return false;
	if (product?.available === false) return true;
	return getTotalStock(product?.stocks, storeId) <= 0;
}
